module.exports = __webpack_public_path__ + "static/media/M44ws.0bfb341d.pdf";